import React from 'react';
import css from './GlobalTable.less';
import GlobalPagination from 'src/components/StyledPagination/GlobalPagination';
import _Query, { EnumQueryType } from 'src/constrains/Query1';
import Table from '@/src/components/EditableTable/EditableTable';
import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import Selector from 'src/components/TableColSelector/ColSelector';
import { get } from 'lodash';
interface IProps {
  columns;
  dataSource;
  pagination?;
  id: string;
  onRow?: any;
  hideHeader?: boolean; //不展示table上方的设置和多选展示及批量操作
  hideRowSelection?: boolean;
  hidePagination?: boolean;
  disableSelectButton?: boolean; //是否隐藏Bulk Edit按钮
  buttonMenu?; //配置Bulk Edit
  expandable?;
  current?;
  pageSize?;
  setCurrent?;
  setPageSize?;
  total?;
  rowKey?;
  setSelectedAll?;
  // rowSelection?;
  rowSelection?;
  selectedRowKeys?;
  mappedSelectedKeys?;
  loading?;
  queryProps?;
  allProductsUuid?;
  hideQuery?;
  addFun?;
  addText?;
  rowDeleteFunc?;
  selectedAll?;
  className?;
  totalText?: string;
  onTableChange?: string;
  handleTableSettingChange?; //redux中保存的配置table columns的action,如不需缓存则不需要传
  tableSettings?; //redux中保存的配置table columns的key,不传则默认为展示state中的数据
  onColChange?;
  displayCol?;
  colsFromParent?: boolean;
  showSorterTooltip?: boolean;
  onChange?;
  hideBulkEditor?: boolean;
  defaultCol?: boolean;
}
const GlobalTable = (props: IProps) => {
  const {
    columns, //宽度和minWidth不能用%！
    dataSource,
    // disableSelectButton,
    buttonMenu,
    pagination = {},
    id,
    hideRowSelection,
    hideHeader,
    hidePagination,
    expandable,
    current,
    pageSize,
    setCurrent,
    setPageSize,
    total,
    loading,
    rowKey,
    rowSelection = {},
    selectedRowKeys,
    //mappedSelectedKeys,
    queryProps = {},

    hideQuery,
    totalText,
    selectedAll,
    setSelectedAll,
    className,
    // handleTableSettingChange,
    // colsFromParent,
    onColChange,
    hideBulkEditor,
    defaultCol,
    ...rest
  } = props;

  // const [_allColumns, setAllColumns] = useState(columns || []);
  const allColumns = columns;
  // const allColumns = colsFromParent?
  //  React.useEffect(() => {
  //    if (displayCol && displayCol !== allColumns) {
  //      setAllColumns(displayCol);
  //    }
  //  }, [displayCol]);
  const handleOnDisplayColChange = (col) => {
    const _col = col.map((i) => {
      const { default: d } = i;
      if (!d) {
        return { ...i, sortOrder: '' };
      } else {
        return i;
      }
    });

    if (onColChange) {
      onColChange(_col);
    }
    // if (!colsFromParent) setAllColumns(col);
  };
  // useEffect(() => {
  //   const columnArray = _.cloneDeep(columns || []);
  //   if (!colsFromParent) {
  //     handleOnDisplayColChange(columnArray);
  //   }
  // }, [columns]);

  // const saveColumns = (tableSettings || []).length
  //   ? allColumns.map((o) => {
  //       if (tableSettings.includes(o.key)) {
  //         o.default = true;
  //       } else {
  //         o.default = false;
  //       }
  //       return o;
  //     })
  //   : [];
  const showSet = allColumns.filter((column) => column.optional); //显示在下拉框里面的选项，col

  const _handleOnColChange = (columnArray) => {
    handleOnDisplayColChange(columnArray);
    // const allColumnsKey = columnArray.map((column) => {
    //   if (column.default) {
    //     return column.key;
    //   }
    // });
    // if (handleTableSettingChange) handleTableSettingChange(allColumnsKey);
  };

  const handleOnColChange = (col = []) => {
    handleOnDisplayColChange(col);
  };
  const pageOnChange = (page, pageSize) => {
    setCurrent(page - 1);
  };
  const pageSizeChange = (value) => {
    setPageSize(value.value);
    setCurrent(0);
  };

  //选择全部
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = dataSource.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };
  //重置设置
  const setReset = () => {
    const _c = columns.map((i, index) => {
      //const {default}=i;
      const d = get(defaultCol, `${index}.default`);
      return { ...i, default: d };
    });
    _handleOnColChange(_c || []);
  };
  //配置每页展示条数
  const pageSizeOption = [20, 60, 100];

  const handleOnSearchChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ search: e, type: EnumQueryType.search });
    }
  };

  const handleOnFilterChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ filter: e, type: EnumQueryType.filter });
    }
  };

  const handleOnSortChange = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ sort: e, type: EnumQueryType.sort });
    }
  };

  const handleOnSearchClose = (e) => {
    if (queryProps.onSearchChange) {
      queryProps.onSearchChange({ item: e, type: EnumQueryType.closeTag });
    }
  };

  return (
    <React.Fragment>
      {/* {!hideQuery && <Query {...queryProps} />} */}
      {!hideQuery && (
        <div className={css.queryContainer}>
          <_Query
            onSearchChange={handleOnSearchChange}
            onFilterChange={handleOnFilterChange}
            onSortChange={handleOnSortChange}
            onTagClose={handleOnSearchClose}
            filters={queryProps.filters || []}
            sortList={queryProps.sortList || []}
            data={queryProps.searchConditions || []}
          />
        </div>
      )}
      {/* {(queryProps.searchListArray.length > 0 ||
        queryProps.filter.length > 0) &&
        !dataSource.length && <TableNoData />} */}
      {dataSource.length && !hideHeader ? (
        <div className={css.tableHeader}>
          {!hideBulkEditor ? (
            <BulkEditor
              selectAll={selectAll}
              selectedAll={selectedAll}
              buttonMenu={buttonMenu}
              total={total}
              dataSource={dataSource}
              selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
              //allSelected={mappedSelectedKeys}
            />
          ) : (
            <div />
          )}

          {showSet.length > 0 && (
            <Selector
              allColumns={allColumns}
              onChange={handleOnColChange}
              setReset={setReset}
            />
          )}
        </div>
      ) : (
        ''
      )}

      <Table
        id={id}
        // className={css.globalTable}
        columns={allColumns}
        dataSource={dataSource}
        className={className}
        rowKey={rowKey}
        pagination={false}
        expandable={expandable}
        {...(!hideRowSelection && { rowSelection })}
        loading={loading}
        {...rest}
      />

      {!hidePagination ? (
        <GlobalPagination
          pageOnChange={pageOnChange}
          totalText={totalText}
          pageSize={pageSize}
          pageSizeOption={pageSizeOption}
          pageSizeChange={pageSizeChange}
          total={total}
          current={current + 1}
          paginationProps={pagination}
          pageSizeWidth={120}
          setCurrent={setCurrent}
        />
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
export default GlobalTable;
